import React, { Component } from 'react'
import axios from 'axios';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import swal from 'sweetalert';


export default class SelfResetPassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userPassword    : {
                userCode         : localStorage.getItem("userCode"),
                userOldPassword  : "",
                userPassword     : "",
                userRePassword   : ""
            },
            userCodeError          : "",
            userOldPasswordError    : "",
            userPasswordError       : "",
            userRePasswordError     : ""
        }
    }
    handleChange = name => e => {
        var tempData = this.state.userPassword;
        tempData[e.target.name] = e.target.value;
        var errorVar = e.target.name + "Error";
        this.setState({userPassword : tempData,[`${errorVar}`]: ""})
    }
    submit = () => {
        if(this.state.userPassword.userOldPassword === ""){
            this.setState({userOldPasswordError : "Please Enter Old Password"})
        }
        if(this.state.userPassword.userPassword === ""){
            this.setState({userPasswordError : "Please Enter New Password"})
        }
        if(this.state.userPassword.userRePassword === ""){
            this.setState({userRePasswordError : "Please Enter New Password"})
        }
        if(this.state.userPassword.userPassword !== this.state.userPassword.userRePassword){
            this.setState({userRePasswordError : "Password Do Not Match"})
        }
        if(this.state.userPassword.userOldPassword !== "" && this.state.userPassword.userPassword !== "" && (this.state.userPassword.userPassword === this.state.userPassword.userRePassword)){
            axios.patch(APIURL + '/api/user/patch/selfresetpassowrd', { userCode : this.state.userPassword.userCode, oldPassword : this.state.userPassword.userOldPassword,password : this.state.userPassword.userPassword })
                    .then(res => {
                        if(res.data.errorCode === 0){
                                window.location.href = '/signin'
                        }else{
                            swal(res.data.errorMsg);
                        }
                    })
                    .catch(res=>{
                        swal("Something Went Wrong")
                    })
        }
            
    }
    componentDidMount = () =>{
        this.setState({userPassword : {
            userCode        : localStorage.getItem("userCode"),
            userOldPassword : "",
            userPassword     : "",
            userRePassword     : ""
        }})
    }
    render() {
        return ( 
        
            <div className="content-wrapper">
            <div className="content">
                <div className="container-fluid">
            <div className="col-sm-12" >
            <div className="resetpassword">
           
                 {/* <div className="row"> */}
                <div className="login-box">
                    {/* <div className="login-logo">
                        <span><b>IPM Application </b></span>
                    </div> */}
                    <div className="login-box-body">
                        <p className="login-box-msg" style={{fontSize:"20px"}}>
                                Reset Password <br />
                        </p>
                        <div className="form-group has-feedback">
                            <input type="text" className="form-control login-textbox" name="userCode" placeholder="UserCode" onChange={this.handleChange("userCode")} value={this.state.userPassword.userCode} disabled/>
                            <span className="glyphicon glyphicon-envelope form-control-feedback" />
                            <span style={{ fontSize: 11, color: "red", marginTop: -15 }}>{this.state.userCodeError} </span>
                        </div>
                        <div className="form-group has-feedback">
                            <input type="password" className="form-control login-textbox" name="userOldPassword" placeholder="Old Password" onChange={this.handleChange("userPassword")} value={this.state.userPassword.userOldPassword}/>
                            <span className="glyphicon glyphicon-envelope form-control-feedback" />
                            <span style={{ fontSize: 11, color: "red", marginTop: -15 }}>{this.state.userOldPasswordError} </span>
                        </div>
                        <div className="form-group has-feedback">
                            <input type="password" className="form-control login-textbox" name="userPassword"  placeholder="Password" onChange={this.handleChange("userPassword")} value={this.state.userPassword.userPassword}/>
                            <span className="glyphicon glyphicon-envelope form-control-feedback" />
                            <span style={{ fontSize: 11, color: "red", marginTop: -15 }}>{this.state.userPasswordError} </span>
                        </div>
                        <div className="form-group has-feedback">
                            <input type="password" className="form-control login-textbox" name="userRePassword"  placeholder="Re-Password" onChange={this.handleChange("userRePassword")} value={this.state.userPassword.userRePassword}/>
                            <span className="glyphicon glyphicon-envelope form-control-feedback" />
                            <span style={{ fontSize: 11, color: "red", marginTop: -15 }}>{this.state.userRePasswordError} </span>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col-lg-4">
                            </div>
                            <div className="col-lg-8">
                                <button type="submit" className="btn btn-primary btn-block " onClick={() =>this.submit()}>Change Password</button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            </div>
            </div>
        )
    }
}
